
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/branch"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('branch_list') }}</router-link> 
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="clickSaveHandler">
                <i class="fa fa-floppy-o"></i> {{ $t('save') }}
            </button>
        </div>
        <div class="x_body">
            <div class="card f_card">
            <div class="card-body">
                <div v-if="$v.$error" class="alert alert-danger x-error">
                    <div class="error" v-if="!$v.model.Name.required">- សូមធ្វើការបញ្ចូលឈ្មោះសាខា</div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group"  :class="{ 'form-group-error': $v.model.Name.$error }">
                            <label class="label-control">{{ $t('branch_name') }}
                                <span class="text-danger">*</span>
                            </label>
                            <div>
                                <input class="form-control form-control-sm" type="text" v-model="$v.model.Name.$model"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="blue">{{ $t('type') }}</label>
                                    <div>
                                        <select class="form-control form-control-sm" v-model="model.TypeId">
                                            <option value="1">{{$t('branch')}}</option>
                                            <option value="2">{{$t('stock')}}</option>
                                            <option value="3">{{$t('shop')}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="blue">{{ $t('phone') }} </label>
                                    <div>
                                        <input class="form-control form-control-sm" type="text" v-model="model.Phone"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="blue">{{ $t('branch_address') }} </label>
                            <div>
                                <textarea class="form-control" id="branch_address" v-model="model.Address"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>          
        </div>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
export default {
    data: function(){
        return {
            model: {
                TypeId: 1,
                Name: '',
                Address: ''
            },
            actionLink: 'branch/save',
            title: this.$t('branch_create')
        }
    },
    created(){
        var id = this.$route.params.id;
        if(id != undefined){
            this.findById(id);
            this.actionLink = 'branch/update';
        }
    },
    validations: {
        model :{
            Name: { required }
        }
    },
    methods: {
        findById: function(id){
            var loading = this.$loading.show();
            this.$api().post('branch/find', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    this.model = res.data.Data;
                    this.title = this.$t('branch_edit') +' ['+ this.model.Name + ']';
                }
            }).finally(function(){ loading.hide(); });
        },
        clickSaveHandler: function(){
            this.$v.$touch();
            if(!this.$v.$invalid) {
                var loading = this.$loading.show();
                this.$api().post(this.actionLink, this.model).then(res => {
                    if (this.$isValid(res)) {
                        this.$router.push('/branch');
                    }
                }).finally(function () {
                    loading.hide();
                });
            }
        }
    }
}
</script>
